import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('device/index', {params});
    },
    show(id) {
        return Service().get('device/show/'+id);
    },
    create(params) {
        return Service().post('device/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('device/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('device/delete/'+id);
    },
    requestResync(id, params) {
        return Service().post('device/request-resync/'+id, params);
    },
    getResyncPreview(id) {
        return Service().get('device/resync-preview/'+id);
    },
    confirmResync(id) {
        return Service().post('device/confirm-resync/'+id);
    },
    cancelResync(id) {
        return Service().post('device/cancel-resync/'+id);
    },
}
